import React from "react";
import ClassNames from "classnames";
import * as s from "./s.module.scss"


const Container = ({
  children,
  className,
  fluid,
  small,
  indent,
  noGutters,
  containerRef,
  ...props
}) => {
  const containerClasses = {
    [s.container]: true,
    [s.containerFluid]: fluid,
    [s.containerSmall]: small,
    [s.containerIndent]: indent
  };

  return (
    <div
      {...props}
      className={ClassNames(containerClasses, { [s.noGutters]: noGutters }, className)}
      ref={containerRef}
    >
      {children}
    </div>
  );
};

export default Container;
